import React, { useState } from 'react';
import stateItems from 'components/AddressFields/StateSelect/data';
import { Input, Select } from 'syngenta-digital-cropwise-react-ui-kit';
import ChevronDown from 'assets/chevron_down.svg?react';
import ChevronUp from 'assets/chevron_up.svg?react';
import { useFormikContext } from 'formik';
import './index.css';

const AddressFields = () => {
  const { values, handleChange, handleBlur } = useFormikContext();
  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);
  return (
    <>
      <div className="col-span-2 mb-4 mr-4">
        <label
          htmlFor="addressLineOne"
          className="text-neutral-60 tracking-tighter text-sm block"
        >
          Address Line 1
        </label>
        <Input
          value={values.addressLineOne}
          placeholder=""
          type="text"
          name="addressLineOne"
          id="addressLineOne"
          className="m-0"
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
      <div className="col-span-2 mb-4 mr-4">
        <label
          htmlFor="addressLineTwo"
          className="text-neutral-60 tracking-tighter text-sm block"
        >
          Address Line 2
        </label>
        <Input
          value={values.addressLineTwo}
          placeholder=""
          type="text"
          id="addressLineTwo"
          name="addressLineTwo"
          className="m-0"
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
      <div className="col-span-2 mb-4 mr-4">
        <label
          htmlFor="city"
          className="text-neutral-60 tracking-tighter text-sm block"
        >
          City
        </label>
        <Input
          value={values.city}
          placeholder=""
          type="text"
          name="city"
          id="city"
          className="m-0"
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
      <div className="col-span-1 mb-4 mr-4">
        <label
          htmlFor="state"
          className="text-neutral-60 tracking-tighter text-sm block"
        >
          State
        </label>
        <Select
          value={values.state}
          placeholder=""
          name="state"
          id="state"
          size="middle"
          className="w-full address-state-select"
          style={{ margin: '2px 0' }}
          getPopupContainer={triggerNode =>
            triggerNode.parentElement || document.body
          }
          suffixIcon={
            isStateDropdownOpen ? (
              <ChevronUp width={18} height={18} />
            ) : (
              <ChevronDown width={18} height={18} />
            )
          }
          showSearch
          onDropdownVisibleChange={open => setIsStateDropdownOpen(open)}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={value => {
            handleChange({ target: { name: 'state', value } });
          }}
          onBlur={handleBlur}
        >
          <Select.Option value="">Select State</Select.Option>
          {stateItems.map(item => (
            <Select.Option key={item.key} value={item.key}>
              {item.value}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className="col-span-1 mb-4 mr-4">
        <label
          htmlFor="zipCode"
          className="text-neutral-60 tracking-tighter text-sm block"
        >
          Zip Code
        </label>
        <Input
          value={values.zipCode}
          placeholder=""
          type="text"
          name="zipCode"
          id="zipCode"
          size="middle"
          className="m-0"
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    </>
  );
};

export default AddressFields;
